import FilterList from '@/components/content/FilterList'
import DateRangePickerInput from '@/components/date/DateRangePickerInput'
import SearchInput from '@/components/system/SearchInput'
import ShipperCodeSelect from '@/components/system/ShipperCodeSelect'
import SelectBox from '@/components/content/SelectBox'
import { type ShipperScope, canSelectShipper, defaultShipper, selectableShippers, shipperScopeOf } from '@/components/system/shipperScope'
import { lockShipperName } from '@/components/system/shipperScopeOptions'
import { InventoryHistoryReqParams } from '@/services/inventory/inventory.types'
import { DATE_FORMAT } from '@/utils/consts'
import { AuthStorage } from '@/utils/storage/AuthStorage'
import dayjs from 'dayjs'
import { useFormContext } from 'react-hook-form'

export const defaultValues = (parseQs?: InventoryHistoryReqParams, scope: ShipperScope = shipperScopeOf(AuthStorage.user.get())) => ({
  // 기본 화주 = 범위의 기본 화주 코드([defaultShipper] — 재고통합 대상 계정은 MUSINSA, LOGISPRD-15719). 그 밖은 현재 세션 화주 코드(shipper_code — 화주 전환을 반영한다, LOGISPRD-14651).
  //  sprNm 은 이름이 아니라 코드다 — BE 가 shipperCode 와 같은지로 거른다.
  sprNm: parseQs?.sprNm ?? defaultShipper(scope).shipperCode,
  clsMonthM: parseQs?.clsMonthM ?? [dayjs().subtract(3, 'month').format(DATE_FORMAT.dateMonthSearch), dayjs().format(DATE_FORMAT.dateMonthSearch)],
})

interface InventoryHistoryFormProps {
  /** 화면이 만든 화주 범위([withCoMingle]). 폼은 범위를 따로 만들지 않는다 (LOGISPRD-15652) */
  scope: ShipperScope
  onSearch(values: InventoryHistoryReqParams): void
}
export const InventoryHistoryForm = ({ onSearch, scope }: InventoryHistoryFormProps) => {
  const { setValue, watch, reset, handleSubmit } = useFormContext<InventoryHistoryReqParams>()
  const values = watch()

  return (
    <FilterList
      list={[
        [
          {
            label: '화주명',
            value: scope.locked && canSelectShipper(scope) ? (
              <SelectBox<string>
                block
                placeholder={false}
                value={values.sprNm}
                options={selectableShippers(scope).map((s) => ({ value: s.shipperCode, label: s.shipperName }))}
                onChange={(v) => setValue('sprNm', v)}
              />
            ) : scope.locked ? (
              // 화주 잠금(LOGISPRD-14653) — 자기 화주로 고정하고 화주 셀렉트를 그리지 않는다(1.0 FilterBar 규칙)
              <SearchInput value={scope.shipperName} disabled />
            ) : (
              <ShipperCodeSelect value={values.sprNm} onChange={(v) => setValue('sprNm', v)} />
            ),
          },
          {
            label: '마감기준월',
            value: (
              <DateRangePickerInput
                value={values.clsMonthM}
                onChange={(v) => {
                  const [start, end] = v
                  setValue('clsMonthM', [
                    start ? dayjs(start).format(DATE_FORMAT.dateMonthSearch) : '',
                    end ? dayjs(end).format(DATE_FORMAT.dateMonthSearch) : '',
                  ])
                }}
                dateFormat={DATE_FORMAT.dateMonth}
                showMonthYearPicker
              />
            ),
            required: true,
          },
        ],
      ]}
      onReset={() => reset(lockShipperName(defaultValues(undefined, scope), scope))}
      onSearch={handleSubmit(onSearch)}
    />
  )
}
